export default __webpack_public_path__ + "static/media/solar_panel.96183a7a.jpg";